import { render, staticRenderFns } from "./adminProcessesAndSubaccounts.vue?vue&type=template&id=698d908a&scoped=true"
import script from "./adminProcessesAndSubaccounts.vue?vue&type=script&lang=js"
export * from "./adminProcessesAndSubaccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698d908a",
  null
  
)

export default component.exports